import React from 'react';
import { RestoreBackupModalProps } from './RestoreBackupModal.types';
import WarningModal from '../WarningModal/WarningModal';

export default function RestoreBackupModal({
	showRestoreModal,
	handleRestoreBackup,
	handleDeleteBackup
}: RestoreBackupModalProps) {
	return (
		<WarningModal
			title="Restore Local Version"
			content="You have a locally saved version of this form that has not been saved. Would you like to load your local version? (note that the local version will not be recoverable if it is deleted)."
			open={showRestoreModal}
			handleClose={handleRestoreBackup}
			handleConfirm={handleDeleteBackup}
			confirmButtonText="Delete Local Version"
			closeButtonText="Reload"
		/>
	);
}
